import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ApplicationHttpClient } from '@base/http-client';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class ViewService {
  constructor(
    private http: ApplicationHttpClient,
  ) { }

  setDefaultViewStatus(viewId: number, newStatus: boolean) {
    const payload = {status: newStatus};
    return this.http.Post(`views/${viewId}/set-default-status/`, payload).pipe(
      map((res) => res),
      catchError((err) => throwError(err))
    );
  }

  getViewSnapshot(viewId: number, emailLoginAs: string = null) {
    const queryParams: object = (emailLoginAs !== null) ? {email: emailLoginAs, } : null;

    return this.http.Get(`views/${viewId}/get-snapshot/`, queryParams).pipe(
      map((res) => res),
      catchError((err) => throwError(err))
    );
  }
}
